import { render, staticRenderFns } from "./FoldTxt2.vue?vue&type=template&id=0f64e4de&"
import script from "./FoldTxt2.vue?vue&type=script&lang=js&"
export * from "./FoldTxt2.vue?vue&type=script&lang=js&"
import style0 from "./FoldTxt2.vue?vue&type=style&index=0&id=0f64e4de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports